import { createContext } from 'react';
import type { TypeWebpageDetailed } from 'types/autogen/contentful';

type TemplateType = NonNullable<TypeWebpageDetailed['fields']['template']>;

interface ContentfulContextType {
    template?: TemplateType['sys']['contentType']['sys']['id'];
}

const ContentfulContext = createContext<ContentfulContextType | undefined>(undefined);

export default ContentfulContext;
